import InternalLinkingGC from '@skyscanner-internal/global-components/internal-links';
import {
  ACTION_TYPE,
  COMPONENT_NAME,
} from '@skyscanner-internal/landing-pages-shared-constants/constants';

import logMiniEventHelper from '../../mini-event/logMiniEventHelper';
import withErrorBoundary from '../ErrorBoundary';
import IntersectionObserverWrapper from '../IntersectionObserverWrapper/IntersectionObserverWrapper';

import type { InternalLinksProps } from '@skyscanner-internal/global-components/internal-links';

import STYLES from './InternalLinksGCStyles.module.scss';

const InternalLinking = (props: InternalLinksProps) => {
  const { tabGroups, title } = props;

  if (!title || !tabGroups?.length) {
    return null;
  }

  return (
    <div className={STYLES.Content}>
      <InternalLinkingGC {...props} />
    </div>
  );
};

const InternalLinksWrapper = (props: InternalLinksProps) => (
  <IntersectionObserverWrapper
    onElementSeen={() =>
      logMiniEventHelper({
        action_type: ACTION_TYPE.COMPONENT_VISIBLE,
        component_name: COMPONENT_NAME.INTERNAL_LINKS,
      })
    }
  >
    <InternalLinking {...props} />
  </IntersectionObserverWrapper>
);

const InternalLinksWithErrorBoundary = withErrorBoundary(
  InternalLinksWrapper,
  'internal-links-component',
);

export default InternalLinksWithErrorBoundary;
